import { formatMoney, currencySymbol } from "../../currency";
import { formatFullyQualifiedUrl } from "../../../../tablescape/utilities";

export default class Klaviyo {
  constructor() {
    window._learnq = window._learnq || [];
  }

  get name() {
    return "Klaviyo";
  }

  viewedProduct(data) {
    window._learnq.push([
      "track",
      "Viewed Product",
      {
        ...data,
        ImageURL: formatFullyQualifiedUrl(data.ImageURL),
        URL: formatFullyQualifiedUrl(data.URL),
      },
    ]);
    window._learnq.push([
      "trackViewedItem",
      {
        Categories: data.Categories,
        ImageUrl: formatFullyQualifiedUrl(data.ImageURL),
        ItemId: data.ProductID,
        Market: data.market,
        Title: data.Name,
        Url: formatFullyQualifiedUrl(data.URL),
        Metadata: {
          Brand: data.Brand,
          Price: data.Price,
          CompareAtPrice: data.CompareAtPrice,
        },
      },
    ]);
  }

  addedToCart(data) {
    const lineItem = data.cart.items.find((item) => data.item.id === item.id);
    let productJson;
    if (document.querySelector(".js-product-json")) {
      productJson = JSON.parse(
        document.querySelector(".js-product-json").innerHTML
      );
    }

    const price = `${currencySymbol()}${formatMoney(
      lineItem.price,
      "{{ amount }}"
    )}`;

    const klaviyoData = {
      Brand: lineItem.vendor,
      Categories: productJson?.productCollections ?? null,
      CompareAtPrice: price,
      ImageURL: formatFullyQualifiedUrl(lineItem.image),
      Market: data.market,
      Name: lineItem.title,
      Price: price,
      ProductID: lineItem.variant_id,
      URL: formatFullyQualifiedUrl(lineItem.url),
    };
    window._learnq.push(["track", "Added to Cart", klaviyoData]);
  }

  bundleAddedToCart(data) {
    let productJson;
    let klaviyoData;

    if (document.querySelector(".js-product-json")) {
      productJson = JSON.parse(
        document.querySelector(".js-product-json").innerHTML
      );
    }

    if (productJson) {
      const { product, productUrl, productCollections } = productJson;

      const price = `${currencySymbol()}${formatMoney(
        product.price,
        "{{ amount }}"
      )}`;
      const compareAtPriceMax = `${currencySymbol()}${formatMoney(
        product.compare_at_price_max,
        "{{ amount }}"
      )}`;

      klaviyoData = {
        Brand: product.vendor,
        Categories: productCollections,
        CompareAtPrice: compareAtPriceMax,
        ImageURL: formatFullyQualifiedUrl(product.featured_image),
        Name: product.title,
        Market: data.market,
        Price: price,
        ProductID: product.id,
        URL: productUrl,
      };
    } else {
      const price = `${currencySymbol()}${formatMoney(
        data.bundleProduct.price,
        "{{ amount }}"
      )}`;
      const compareAtPrice = `${currencySymbol()}${formatMoney(
        data.bundleProduct.compareAtPrice,
        "{{ amount }}"
      )}`;

      klaviyoData = {
        Brand: "Our Place",
        CompareAtPrice: compareAtPrice,
        ImageURL: formatFullyQualifiedUrl(data.bundleProduct.imageURL),
        Name: data.bundleProduct.title,
        Market: data.market,
        Price: price,
        ProductID: data.bundleProduct.id,
        URL: window.location.href,
      };
    }

    window._learnq.push(["track", "Added to Cart", klaviyoData]);
  }

  userData({ email, firstName, lastName, phoneNumber, ...data }) {
    window._learnq.push([
      "identify",
      {
        ...data,
        $email: email,
        $first_name: firstName,
        $last_name: lastName,
        $phone_number: phoneNumber,
      },
    ]);
  }

  loadedExperiment(data) {
    window._learnq.push([
      "track",
      "Experiment Assigned",
      {
        ...data,
      },
    ]);
  }
}
